import { Component, useContext, useEffect, useRef } from "react";
import { getConfigMap, onReturnKey } from "lib/helpers";
import BoxModel from "./Properties/components/BoxModel";
import { useAttribute } from "lib/hooks";
import _ from "lodash";
import schema from "lib/schema";
import { rootNamespace } from "config";
import Input from "./Properties/components/Input";
import ColorPicker from "./Properties/components/ColorPicker";
import Border from "./Properties/components/composite/Border";
import Checkbox from "./Properties/components/Checkbox";
import Label from "./Properties/components/Label";
import { TreeContext } from "pages/Editor";

/**
 * same as Input but with ref
 * @see {Input}
 *
 * @param {object} props
 */
function StyleInput(props) {
  const ref = useRef();
  return <Input {...{ ref, ...props }} />;
}

function AttributeInput({ attribute }) {
  const ref = useRef();
  const [attr, setAttribute] = useAttribute(attribute);
  useEffect(() => {
    ref.current.value = attr || "";
  }, [attr, setAttribute]);
  return <input ref={ref} type="text" onKeyDown={onReturnKey(setAttribute)} />;
}

function ValueInput() {
  const { selection, update } = useContext(TreeContext);
  function onChange(e) {
    update(selection.path + ".value", e.target.value);
  }
  return (
    <div className="vc">
      <input onChange={onChange} value={selection.component.value || ""} />
    </div>
  );
}

function Dimensions() {
  return (
    <div className="inps d">
      <StyleInput
        attr="width"
        placeholder="Width"
        loadStyle={false}
        onlyValue={false}
      />
      <StyleInput
        attr="height"
        placeholder="Height"
        loadStyle={false}
        onlyValue={false}
      />
    </div>
  );
}

function PropertySchema({ name, data }) {
  const { publish } = useContext(TreeContext);
  if (name === "boxModel") return <BoxModel />;
  if (name === "dimensions") return <Dimensions />;
  if (name === "background")
    return (
      <Label title="Background">
        <ColorPicker attr="backgroundColor" />
      </Label>
    );
  if (name === "fontColor")
    return (
      <Label title="Font color">
        <ColorPicker attr="color" />
      </Label>
    );
  if (name === "fontFamily")
    return (
      <Label title="Font family">
        <Input attr="fontFamily" full />
      </Label>
    );
  if (name === "border")
    return (
      <Label title="Border">
        <Border />
      </Label>
    );
  if (name === "draggable") return <Checkbox name="Draggable" />;
  if (name === "borderRadius")
    return (
      <Label title="Border Radius" cls="inp">
        <Input attr="borderRadius" type="number" />
      </Label>
    );
  if (name === "code")
    return (
      <Label title="Code">
        <button
          className="btn"
          onClick={() => publish(rootNamespace, "SHOW_EDITOR")}
        >
          Set action
        </button>
      </Label>
    );
  if (name === "value")
    return (
      <Label title="Label">
        <ValueInput />
      </Label>
    );
  // if(data.type === 'style') {
  //     return <Label>
  //         <StyleInput attr={name} placeholder={data.label} />
  //     </Label>
  // }
  return (
    <Label title={data.label} cls="vc">
      <AttributeInput attribute={name} />
    </Label>
  );
}

class StyleEditor extends Component {
  state = {
    hasError: false,
  };
  configMap = getConfigMap(schema);
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch(e) {
    console.log(e);
  }
  render() {
    if (this.state.hasError) return null;
    return (
      <TreeContext.Consumer>
        {({ selection }) => {
          // issue #6
          const component = _.get(selection, "component", {});
          const config = this.configMap[component.type] || {};
          return (
            <div className="pr">
              {Object.keys(config).map((k) => {
                return (
                  <div className="gp" key={k}>
                    <PropertySchema name={k} data={config[k]} />
                  </div>
                );
              })}
            </div>
          );
        }}
      </TreeContext.Consumer>
    );
  }
}

export default StyleEditor;
